"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PASSWORD_MIN_LENGTH = 6;
var PASSWORD_MAX_LENGTH = 8;

var sequence = function sequence(one, two, actual) {
  return two === actual && one === actual;
};
/**
 * Função que retorna o peso de uma senha.
 * @param password string
 */


exports.StrongerPassword = function (password) {
  var uppercase = 0;
  var lowercase = 0;
  var digits = 0;
  var symbols = 0;
  var digitsOrSymbolsMiddle = 0;
  var requirements = 0;
  var onlyLetters = 0;
  var onlyDigits = 0;
  var repeatedCharacters = 0;
  var consecutiveDigits = 0;
  var consecutiveUppercase = 0;
  var consecutiveLowercase = 0;
  var sequenceLetters = 0;
  var sequenceDigits = 0;
  var score = 0;
  var listAux = [];
  var passwordSplit = password.split('');
  var validations = {
    haveLetter: false,
    haveNumber: false,
    correctSize: false
  };
  passwordSplit.forEach(function (char, index) {
    if (/([A-Za-z])/.test(char)) {
      validations.haveLetter = true;
      symbols++;

      if (index > 0 && index < passwordSplit.length - 1) {
        digitsOrSymbolsMiddle++;
      }
    } else if (/([0-9])/.test(char)) {
      validations.haveNumber = true;
      digits++;

      if (index > 0 && index < passwordSplit.length - 1) {
        digitsOrSymbolsMiddle++;
      }

      if (index > 0 && /([0-9])/.test(passwordSplit[index - 1])) {
        consecutiveDigits++;

        if (index > 1 && /([0-9])/.test(passwordSplit[index - 2]) && sequence(passwordSplit[index - 2], passwordSplit[index - 1], char)) {
          sequenceDigits++;
        }
      }
    } else {
      if (index > 1 && !/([0-9])/.test(passwordSplit[index - 2]) && !/([0-9])/.test(passwordSplit[index - 1]) && sequence(passwordSplit[index - 2].toLowerCase(), passwordSplit[index - 1].toLowerCase(), char.toLowerCase())) {
        sequenceLetters++;
      }

      if (/[A-Z]/.test(char)) {
        uppercase++;

        if (index > 0 && /[A-Z]/.test(passwordSplit[index - 1])) {
          consecutiveUppercase++;
        }
      } else {
        lowercase++;

        if (index > 0 && /[a-z]/.test(passwordSplit[index - 1])) {
          consecutiveLowercase++;
        }
      }
    }

    var lowerCharacter = char.toLowerCase();

    if (!(listAux.indexOf(lowerCharacter) >= 0)) {
      listAux.push(lowerCharacter);
      var repeated = 0;

      for (var i = 0; i < passwordSplit.length; i++) {
        if (passwordSplit[i].toLowerCase() === lowerCharacter) {
          repeated++;
        }
      }

      if (repeated > 1) {
        repeatedCharacters += repeated * (repeated - 1);
      }
    }
  });

  if (passwordSplit.length >= PASSWORD_MIN_LENGTH) {
    requirements++;

    if (uppercase > 0) {
      requirements++;
    }

    if (lowercase > 0) {
      requirements++;
    }

    if (digits > 0) {
      requirements++;
    }

    if (symbols > 0) {
      requirements++;
    }

    if (requirements < 4) {
      requirements = 0;
    }
  }

  if (passwordSplit.length >= PASSWORD_MIN_LENGTH && passwordSplit.length <= PASSWORD_MAX_LENGTH) {
    validations.correctSize = true;
  }

  if (digits === passwordSplit.length) {
    onlyDigits = passwordSplit.length;
  }

  if (uppercase + lowercase === passwordSplit.length) {
    onlyLetters = passwordSplit.length;
  }

  if (password) score += password.length * 4;
  if (uppercase > 0) score += (password.length - uppercase) * 2;
  if (lowercase > 0) score += (password.length - lowercase) * 2;
  if (digits > 0 && (uppercase > 0 || lowercase > 0 || symbols > 0)) score += digits * 4;
  if (symbols > 0) score += symbols * 6;
  if (digitsOrSymbolsMiddle > 0) score += digitsOrSymbolsMiddle * 2;
  if (requirements > 0) score += requirements * 2;
  if (onlyLetters > 0) score -= onlyLetters;
  if (onlyDigits > 0) score -= onlyDigits;
  if (repeatedCharacters > 0) score -= repeatedCharacters;
  if (consecutiveUppercase > 0) score -= consecutiveUppercase * 2;
  if (consecutiveLowercase > 0) score -= consecutiveLowercase * 2;
  if (consecutiveDigits > 0) score -= consecutiveDigits * 2;
  if (sequenceDigits > 0) score -= sequenceDigits * 3;
  if (sequenceLetters > 0) score -= sequenceLetters * 3;

  if (score < 25 || score === 25) {
    return {
      score: 0,
      validation: validations
    };
  } else if (score < 50 || score === 50) {
    return {
      score: 1,
      validation: validations
    };
  } else if (score < 75 || score === 75) {
    return {
      score: 2,
      validation: validations
    };
  } else {
    return {
      score: 3,
      validation: validations
    };
  }
};
/**
 * Função que valida se uma senha parametrizada é forte ou não.
 * @param password string
 */


exports.validateStrongPassword = function (password) {
  return !(exports.StrongerPassword(password).score < 2);
};